import { render, staticRenderFns } from "./vetZsmInfo.vue?vue&type=template&id=f0a20eac&"
import script from "./vetZsmInfo.vue?vue&type=script&lang=js&"
export * from "./vetZsmInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports